import React from 'react';
import PropTypes from 'prop-types';
import { TableContainer } from './Styled';

// import styles from './Checkbox.css';

const IPropTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  nodata: PropTypes.string,
};

const defaultProps = {
  columns: [],
  data: [],
  nodata: 'No existen datos para mostrar',
};

const renderTrBody = (row, columns) => {
  const columnsTr = [];
  for (let i = 0; i < columns.length; i += 1) {
    const value = columns[i].Cell ? columns[i].Cell(row[columns[i].accessor]) :
      row[columns[i].accessor];
    columnsTr.push(<td className={columns[i].typeCell}>{value}</td>);
  }
  return columnsTr;
};

const Table = props => (
  <TableContainer>
    <table className="rtable">
      <thead>
        <tr>
          {props.columns.map(item => <th className={item.typeCell}>{item.Header}</th>)}
        </tr>
      </thead>
      <tbody>
        {
          props.data.length > 0 ?
          props.data.map(item => <tr>{renderTrBody(item, props.columns)}</tr>) :
          <tr><td colSpan={props.columns.length} style={{ textAlign: 'center' }}>{props.nodata}</td></tr>
        }
      </tbody>
    </table>
  </TableContainer>
);

Table.propTypes = IPropTypes;
Table.defaultProps = defaultProps;

export { Table };



// WEBPACK FOOTER //
// ./src/common/table-data/Table.jsx